import List from "components/Admin/Aspirations/AspirationsQuestions/List/List"
import React from "react"

const ListPage = () => {
    return (
        <React.Fragment>
            <List />
        </React.Fragment>
    )
}
export default ListPage
